<div mat-dialog-title class="right">
  <button
    aria-label="close"
    mat-button
    [mat-dialog-close]="false"
    class="close-button"
  >
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <div class="center">
    <div class="joint-app-confirmation-icon"></div>
  </div>
  <br />
  <div class="center">
    <h3 class="section-label">Joint Account</h3>
  </div>
  <br />
  <p>
    To continue, confirm that all applicants are physically present. Applicants
    must submit required documents at the same time.
  </p>
</div>
<br />
<div class="center">
  <button
  class="secondary-btn-action"
    mat-stroked-button
    color="primary"
    [mat-dialog-close]="false"
    cdkFocusInitial
  >
    CANCEL
  </button>
  &nbsp;&nbsp;&nbsp;
  <button
  class="primary-btn-action"
    mat-flat-button
    color="primary"
    [mat-dialog-close]="true"
    cdkFocusInitial
  >
    OK
  </button>
</div>
<br />
